import { render, staticRenderFns } from "./myOrder2.vue?vue&type=template&id=b80b367a&scoped=true&"
import script from "./myOrder2.vue?vue&type=script&lang=js&"
export * from "./myOrder2.vue?vue&type=script&lang=js&"
import style0 from "./myOrder2.vue?vue&type=style&index=0&id=b80b367a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80b367a",
  null
  
)

export default component.exports